// extracted by mini-css-extract-plugin
module.exports = {"root":"MessagesList_root__34mUU","header":"MessagesList_header__3RxIB","chat":"MessagesList_chat__2gfCG"};